const getters = {
  device: (state) => state.app.device,

  avatar: (state) => state.user.avatar,
  nickname: (state) => state.user.nickname,
}

export default getters
